var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"ruleForm",attrs:{"model":_vm.item,"label-position":"left","label-width":"160px"}},[_c('video-item',{ref:"video",attrs:{"isOutstream":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }